import { useEffect, useState } from 'react'
import { Row, Col, Typography } from 'antd'

import Image from '../assets/logo2.png'

import { useParams } from 'react-router-dom'
import moment from 'moment'

// Component
import MainHeader from '../components/MainHeader'
import GmCard from '../components/playerInterface/GmCard'
import PlayerStats from '../components/playerInterface/PlayerStats'
import ContractInfo from '../components/playerInterface/ContractInfo'
import PlayerInfoBottom from '../components/PlayerInfoBottom'
import Loader from '../components/Loader'

import { getSingleAuctionPlayer } from '../redux/actions/rosterAction'

const PlayerWinningBid = () => {
  const [state, setState] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const params = useParams()

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    !isLoading && setIsLoading(true)
    const res = await getSingleAuctionPlayer(params?.id)
    if (res) {
      setState(res)
    }
    setIsLoading(false)
  }

  return (
    <div className='player_interface_container'>
      <MainHeader />

      <hr className='divider' />

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <GmCard playerData={state} bidWinningPage={true} />

          <PlayerInfoBottom player={state?.player_id} />

          <section className='bid_section' style={{ marginTop: '20px' }}>
            <Row gutter={[30, 30]} align={'middle'}>
              <Col xs={24}>
                <div className='bid_card'>
                  <img src={Image} />
                  <Typography.Title level={2}>
                    Winning Bid {`$${state?.highestCurrentBid?.toLocaleString()}`}
                  </Typography.Title>
                </div>
              </Col>
            </Row>
          </section>

          <section className='player_info_container'>
            <PlayerStats />
            <ContractInfo data={state?.player_id?.contractInfo} />
          </section>

          <section className='bid_history_container'>
            <div className='header'>
              <h2>BID HISTORY</h2>
            </div>
            <div className='bid_history_body'>
              {state?.bidHistory
                ?.slice()
                ?.sort((a, b) => b.bid - a.bid)
                ?.map((v, i) => {
                  return (
                    <div key={i} className='squad_card_box'>
                      <div>
                        <p className='squad_text2'>date</p>
                        <p className='squad_text1'>
                          {moment(v?.date_time).format('YYYY-MM-DD') || '-'}
                        </p>
                      </div>
                      <div>
                        <p className='squad_text2'>user name</p>
                        <p className='squad_text1'>{v?.user?.userName || '-'}</p>
                      </div>
                      <div>
                        <p className='squad_text2'>team</p>
                        <p className='squad_text1'>{v?.user?.team?.name || '-'}</p>
                      </div>
                      <div style={{ minWidth: '100px' }}>
                        <p className='squad_text2'>bid</p>
                        <p className='squad_text1'>{`$${v?.bid?.toLocaleString()}` || '-'}</p>
                      </div>
                    </div>
                  )
                })}
            </div>
          </section>
        </>
      )}
    </div>
  )
}

export default PlayerWinningBid
